"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ErrorAnimation", {
  enumerable: true,
  get: function get() {
    return _ErrorAnimation["default"];
  }
});
var _ErrorAnimation = _interopRequireDefault(require("./ErrorAnimation"));